<template>
<div class="property">
  <el-dialog title="物业交割" visible :before-close="close" :close-on-click-modal="false">
    <div>
        <div style="margin-bottom:4px;">能耗情况</div>
        <el-table :data="energyConsumption" border>
          <el-table-column label="表项" prop="meterReadType" align="center">
            <template slot-scope="scope">{{meterReadTypeDict[scope.row.meterReadType]}}</template>
          </el-table-column>
          <el-table-column label="户号" align="center">
            <el-input
              slot-scope="scope"
              v-model="scope.row.houseNumber"
              size="small"
              :maxlength="50"
              placeholder="请填写户号"/>
          </el-table-column>
          <el-table-column label="读表" align="center">
            <template slot-scope="scope">
              <div class="energy-number">
                <el-input
                v-model.number="scope.row.meterReadNumber"
                size="small"
                :maxlength="10"
                :placeholder="`请填写${meterReadTypeDict[scope.row.meterReadType]}读数`"/>
                <span  style="font-size:12px; color:#666; position:absolute; top: 2px; right: 10px;">{{scope.row.meterReadType === 'WATERMETER' ? '吨' : '度'}}</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
    </div>
    <template v-if="isEntireRent">
         <!-- <div>
          {{subFormSnap}}
        </div> -->
        <div class="articles-lists" style="margin-top:24px;">
          <div style="margin-bottom:4px;">电器</div>
          <div class="_con">
            <div v-for="(item, key) in electric" :key="key" class="_pair-input">
              <span class="_pair-k">{{electricDict[item.articlesType]}}</span>
              <div class="_pair-v">
                <input v-model.number="item.articlesNumber" class="_input" :maxlength="4"/>
                <span class="_unit">个</span>
              </div>
            </div>
          </div>
        </div>
        <div class="articles-lists" style="margin-top:24px;">
          <div style="margin-bottom:4px;">家具</div>
          <div class="_con">
            <div v-for="(item, key) in furniture" :key="key" class="_pair-input">
              <span class="_pair-k">{{furnitureDict[item.articlesType]}}</span>
              <div class="_pair-v">
                <input v-model.number="item.articlesNumber" class="_input" :maxlength="4"/>
                <span class="_unit">个</span>
              </div>
            </div>
          </div>
        </div>
        <div class="articles-lists" style="margin-top:24px;">
          <div style="margin-bottom:4px;">厨卫</div>
          <div class="_con">
            <div v-for="(item, key) in kitchen" :key="key" class="_pair-input">
              <span class="_pair-k">{{kitchenDict[item.articlesType]}}</span>
              <div class="_pair-v">
                <input v-model.number="item.articlesNumber" class="_input" :maxlength="4"/>
                <span class="_unit">个</span>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template v-else>
        <div class="articles-lists" style="margin-top:24px;">
          <div style="margin-bottom:4px;">公共区域物品清单</div>
          <div class="_con">
            <div v-for="(item, key) in publicMaterials" :key="key" class="_pair-input">
              <span class="_pair-k">{{publicMaterialsDict[item.articlesType]}}</span>
              <div class="_pair-v">
                <input v-model.number="item.articlesNumber" class="_input" :maxlength="4"/>
                <span class="_unit">个</span>
              </div>
            </div>
          </div>
        </div>
        <div class="articles-lists" style="margin-top:24px;">
          <div style="margin-bottom:4px;">房间电器</div>
          <div class="_con">
            <div v-for="(item, key) in roomElectric" :key="key" class="_pair-input">
              <span class="_pair-k">{{roomElectricDict[item.articlesType]}}</span>
              <div class="_pair-v">
                <input v-model.number="item.articlesNumber" class="_input" :maxlength="4"/>
                <span class="_unit">个</span>
              </div>
            </div>
          </div>
        </div>
        <div class="articles-lists" style="margin-top:24px;">
          <div style="margin-bottom:4px;">房间家具</div>
          <div class="_con">
            <div v-for="(item, key) in roomFurniture" :key="key" class="_pair-input">
              <span class="_pair-k">{{roomFurnitureDict[item.articlesType]}}</span>
              <div class="_pair-v">
                <input v-model.number="item.articlesNumber" class="_input" :maxlength="4"/>
                <span class="_unit">个</span>
              </div>
            </div>
          </div>
        </div>
        <div class="articles-lists" style="margin-top:24px;">
          <div style="margin-bottom:4px;">房间厨卫</div>
          <div class="_con">
            <div v-for="(item, key) in roomKitchen" :key="key" class="_pair-input">
              <span class="_pair-k">{{roomKitchenDict[item.articlesType]}}</span>
              <div class="_pair-v">
                <input v-model.number="item.articlesNumber" class="_input" :maxlength="4"/>
                <span class="_unit">个</span>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div slot="footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="hitOk">确 定</el-button>
      </div>
  </el-dialog>
</div>
</template>
<script>
const meterReadType = {
  ELECTRICMETER: '电表',
  WATERMETER: '水表',
  GASMETERREAD: '燃气',
}

// 合租
const publicMaterials = {
  TABLE: '餐桌',
  DININGCHAIR: '餐椅',
  TELEVISION: '电视',
  REFRIGERATOR: '冰箱',
  CAMERA: '摄像头',
  ROUTER: '路由器',
  SETTOPBOX: '机顶盒',
  TEATABLE: '茶几',
  TVCABINET: '电视柜',
  OVEN: '烤箱',
  GASSTOVE: '燃气灶',
  LAMPBLACKMACHINE: '油烟机',
  ELECTROMAGNETICFURNACE: '电磁炉',
  MICROWAVEOVEN: '微波炉',
  WASHINGMACHINE: '洗衣机',
  HEATER: '热水器',
  PEDESTALPAN: '坐便器',
  BATHHEATER: '浴霸',
  SOFA: '沙发',
}

const roomElectric = {
  AIRCONDITIONER: '空调',
  COMPUTER: '电脑',
}

const roomFurniture = {
  BED: '床',
  MATTRESS: '床垫',
  BEDSIDECUPBOARD: '床头柜',
  WARDROBE: '衣柜',
  DESK: '写字台',
  OFFICECHAIR: '写字椅',
  ROOMSOFA: '房间沙发',
  ROOMTVCABINET: '房间电视柜',
  ROOMTEATABLE: '房间茶几',
  LOCKER: '置物柜',
  SHOECABINET: '鞋柜',
  DRESSER: '梳妆台',
  TATAMI: '榻榻米',
}

const roomKitchen = {
  ROOMHEATER: '房间热水器',
  ROOMPEDESTALPAN: '房间坐便器',
  ROOMBATHHEATER: '房间浴霸',
}

// 整租
const electric = {
  AIRCONDITIONER: '空调',
  COMPUTER: '电脑',
  TELEVISION: '电视',
  REFRIGERATOR: '冰箱',
  WASHINGMACHINE: '洗衣机',
  CAMERA: '摄像头',
  ROUTER: '路由器',
  SETTOPBOX: '机顶盒',
  CEILINGLAMP: '吸顶灯',
  CHANDELIER: '吊灯',
}

const furniture = {
  BED: '床',
  MATTRESS: '床垫',
  BEDSIDECUPBOARD: '床头柜',
  WARDROBE: '衣柜',
  DESK: '写字台',
  OFFICECHAIR: '写字椅',
  SHOECABINET: '鞋柜',
  TVCABINET: '电视柜',
  TEATABLE: '茶几',
  LOCKER: '置物柜',
  SOFA: '沙发',
  TABLE: '餐桌',
  DININGCHAIR: '餐椅',
  DRESSER: '梳妆台',
  TATAMI: '榻榻米',
  ORNAMENT: '装饰物',
  STACKS: '置物架',
}

const kitchen = {
  HEATER: '热水器',
  PEDESTALPAN: '坐便器',
  BATHHEATER: '浴霸',
  GASSTOVE: '燃气灶',
  LAMPBLACKMACHINE: '油烟机',
  ELECTROMAGNETICFURNACE: '电磁炉',
  MICROWAVEOVEN: '微波炉',
  OVEN: '烤箱',
}
export default {
  data() {
    return {
      subFormSnap: {},
      energyConsumption: [
        {
          meterReadType: 'WATERMETER',
          houseNumber: '',
          meterReadNumber: '',
        },
        {
          meterReadType: 'ELECTRICMETER',
          houseNumber: '',
          meterReadNumber: '',
        },
        {
          meterReadType: 'GASMETERREAD',
          houseNumber: '',
          meterReadNumber: '',
        },
      ],
      meterReadTypeDict: meterReadType,
      publicMaterialsDict: publicMaterials,
      publicMaterials: [],
      roomElectricDict: roomElectric,
      roomElectric: [],
      roomFurnitureDict: roomFurniture,
      roomFurniture: [],
      roomKitchenDict: roomKitchen,
      roomKitchen: [],

      electricDict: electric,
      electric: [],
      furnitureDict: furniture,
      furniture: [],
      kitchenDict: kitchen,
      kitchen: [],

    }
  },
  props: {
    wuyeMessage: {
      type: Array,
      default: () => {
        return []
      }
    },
    nenghaoMessage: {
      type: Array,
      default: () => {
        return []
      }
    },
    rentType: {
      type: String,
      default: ''
    }
  },
  computed: {
    isEntireRent() {
      return this.rentType === 'ENTIRE_RENT'
    },
  },
  methods: {
    close() {
      let val = 'property'
      this.$emit('closeAddCompany', val)
    },
    getArticlesListsByDict(dict) {
      // articlesType 物品类型  articlesNumber物品数量
      let r = []
      for (let k in dict) {
        r.push({
          articlesType: k,
          articlesNumber: 0,
        })
      }
      return r
    },
    // 物业交割表单
    initSubForm() {
      this.subFormSnap = {
        energyConsumption: [
          {
            meterReadType: 'WATERMETER',
            houseNumber: '',
            meterReadNumber: '',
          },
          {
            meterReadType: 'ELECTRICMETER',
            houseNumber: '',
            meterReadNumber: '',
          },
          {
            meterReadType: 'GASMETERREAD',
            houseNumber: '',
            meterReadNumber: '',
          },
        ],

        // 物品清单
        publicMaterials: this.getArticlesListsByDict(publicMaterials),
        roomElectric: this.getArticlesListsByDict(roomElectric),
        roomFurniture: this.getArticlesListsByDict(roomFurniture),
        roomKitchen: this.getArticlesListsByDict(roomKitchen),

        electric: this.getArticlesListsByDict(electric),
        furniture: this.getArticlesListsByDict(furniture),
        kitchen: this.getArticlesListsByDict(kitchen),
      }
      console.log(this.subFormSnap, 2222)
    },
    // 整合数据，以及修改时回填数据
    dealWithWuye() {

      const subForm = JSON.parse(JSON.stringify(this.subFormSnap))
      let {energyConsumption,
        publicMaterials,
        roomElectric,
        roomFurniture,
        roomKitchen,

        electric,
        furniture,
        kitchen,
      } = subForm

      this.energyConsumption = energyConsumption
      this.publicMaterials = publicMaterials
      this.roomElectric = roomElectric
      this.roomFurniture = roomFurniture
      this.roomKitchen = roomKitchen

      this.electric = electric
      this.furniture = furniture
      this.kitchen = kitchen

      console.log('subFormSnap', this.subFormSnap)
      // if (this.rewrite && this.rentContractType.isModify) {
          // 能耗明细
        this.energyConsumption.forEach(item => {
          if (this.nenghaoMessage.length < 1) {
            return
          }
          let sameValue = this.nenghaoMessage.find(it => it.meterReadType === item.meterReadType)
            if (sameValue) {
              item.houseNumber = sameValue.houseNumber
              item.meterReadNumber = sameValue.meterReadNumber
            }
        })
        // 物品清单
        if (this.rentType === 'JOINT_RENT') {
          let joinRent = {
            roomFurniture: this.roomFurniture,
            roomKitchen: this.roomKitchen,
            publicMaterials: this.publicMaterials,
            roomElectric: this.roomElectric
          }
          for (var i in joinRent) {
            this.dealWithWuyPinQingDan(joinRent[i], this.wuyeMessage)
          }
        } else if (this.rentType === 'ENTIRE_RENT') {
          let entireRent = {
            electric: this.electric,
            furniture: this.furniture,
            kitchen: this.kitchen,
          }
          for (var k in entireRent) {
            this.dealWithWuyPinQingDan(entireRent[k], this.wuyeMessage)
          }
        }
        // 修改合同，第一次回写的时候，需要自动绑定到this.subFormSnap,来实现通过验证
        this.subFormSnap = JSON.parse(JSON.stringify({
          energyConsumption: this.energyConsumption,

          publicMaterials: this.publicMaterials,
          roomElectric: this.roomElectric,
          roomFurniture: this.roomFurniture,
          roomKitchen: this.roomKitchen,

          electric: this.electric,
          furniture: this.furniture,
          kitchen: this.kitchen,
        }))
        console.log(this.subFormSnap)
        // this.rewrite = false     // 之后，就为false
      // }
    },
    dealWithWuyPinQingDan(content, data) {
        if (content.length < 1 || data.length < 1) {
          return
        }
        content.forEach(item => {
          let sameValue = data.find(it => it.articlesType === item.articlesType)
          if (sameValue) {
            item.articlesNumber = sameValue.articlesNumber
          }
        })
    },
    // 点击确定
    hitOk() {
      // save snapshot of sub form
      this.subFormSnap = JSON.parse(JSON.stringify({
        energyConsumption: this.energyConsumption,

        publicMaterials: this.publicMaterials,
        roomElectric: this.roomElectric,
        roomFurniture: this.roomFurniture,
        roomKitchen: this.roomKitchen,

        electric: this.electric,
        furniture: this.furniture,
        kitchen: this.kitchen,
      }))

      let {energyConsumption,
        publicMaterials,
        roomElectric,
        roomFurniture,
        roomKitchen,

        electric,
        furniture,
        kitchen,
      } = this.subFormSnap

      const f0 = (item) => Boolean(item.articlesNumber)

      publicMaterials = publicMaterials.filter(f0)
      roomElectric = roomElectric.filter(f0)
      roomFurniture = roomFurniture.filter(f0)
      roomKitchen = roomKitchen.filter(f0)

      electric = electric.filter(f0)
      furniture = furniture.filter(f0)
      kitchen = kitchen.filter(f0)

      let articlesLists = this.isEntireRent
          ? electric.concat(furniture).concat(kitchen)
          : publicMaterials.concat(roomElectric).concat(roomFurniture).concat(roomKitchen)
       let rentType = this.rentType
       console.log(articlesLists)
       if (!articlesLists.length) {
         this.$message.warning('请完成物管交割单的填写')
         return
       }
       this.$emit('getPropertySet', {articlesLists, energyConsumption, rentType})
       this.$emit('closeAddCompany', 'property')
    },
    // getSubForm() {
    //   let {energyConsumption,
    //     publicMaterials,
    //     roomElectric,
    //     roomFurniture,
    //     roomKitchen,

    //     electric,
    //     furniture,
    //     kitchen,
    //   } = this.subFormSnap

    //   const f0 = (item) => Boolean(item.articlesNumber)

    //   publicMaterials = publicMaterials.filter(f0)
    //   roomElectric = roomElectric.filter(f0)
    //   roomFurniture = roomFurniture.filter(f0)
    //   roomKitchen = roomKitchen.filter(f0)

    //   electric = electric.filter(f0)
    //   furniture = furniture.filter(f0)
    //   kitchen = kitchen.filter(f0)

    //   return {
    //     articlesLists: this.isEntireRent
    //       ? electric.concat(furniture).concat(kitchen)
    //       : publicMaterials.concat(roomElectric).concat(roomFurniture).concat(roomKitchen),
    //     energyConsumption: energyConsumption,
    //     // 续租需要的字段
    //     // reletWord: {
    //     //     nrArticlesLists: this.isEntireRent
    //     //     ? electric.concat(furniture).concat(kitchen)
    //     //     : publicMaterials.concat(roomElectric).concat(roomFurniture).concat(roomKitchen),
    //     //   nrEnergyConsumption: energyConsumption,
    //     // }

    //   }

    // },
  },
  created() {
    this.initSubForm()  //
    this.dealWithWuye()
  }
}
</script>
<style lang="scss" scoped>
  .property {
    .energy-number {
      position: relative;
    }
    .articles-lists {
  ._con {
    margin-left: -8px;
    margin-right: -8px;
  }
  ._pair-input {
    display: inline-block;
    margin: 8px;
    // width: calc((100% - 8px * 8) / 4);
    text-align: center;
    border: 1px solid #ccc;
  }

  ._pair-k {
    padding: 4px;
    display: inline-block;
    border-right: 1px solid #ccc;
    box-sizing: border-box;
    min-width: 6em;
  }

  ._pair-v {
    display: inline-block;
    min-width: 4em;
    background: white;
    position: relative;
  }
  ._input {
    width: 4em;
    display: inline-block;
    cursor: pointer;
    position: relative;
    z-index: 1;
    background-color: rgba(0,0,0,0);
    font-size: 12px;
  }

  ._unit {
    display: inline-block;
    width: 2em;
    text-align: right;
    position: absolute;
    right: 4px;
    top: 0;
    z-index: 0;
  }
}
  }
</style>
<style>
  .property .el-dialog{
    width: 800px !important;
  }
</style>




// WEBPACK FOOTER //
// src/components/forms/BusinessContractForm/propertyForm.vue